import { render, staticRenderFns } from "./BeaconSingle.vue?vue&type=template&id=271194ec&"
import script from "./BeaconSingle.vue?vue&type=script&lang=js&"
export * from "./BeaconSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports